import axios from 'axios';

export function fetchSessionUser(token) {
	return axios.post(`${process.env.VUE_APP_AUTH_URL}/authenticate`, {
		idToken: token
	});
}

export function fetchSearchSettings(apikey) {
	return axios.get(`${process.env.VUE_APP_AUTH_URL}/search-settings?apikey=${apikey}`);
}

